export enum TicketsEnum {
    MODULE_ACCESS = 'View',
    CREATE = 'Create',
    UPDATE = 'Update',
    STATUS_CHANGE = 'Status_Change',
    ARCHIVE = 'Archive',
    EXPORT = 'Export',
}